import React, { useState, useEffect } from 'react';
import UserService from '../services/UserService';
import { hasDeals } from '../services/categories';
import Spinner from 'react-bootstrap/Spinner';
import Hero from './Hero';
import DealCard from './DealCard';
import SignUp from './SignUp';
import './Home.css';

const PAGE_SIZE = 12;

function Home2() {
  const [pagenumber, setpagenumber] = useState(0)
  const [iscompleted, setIsCompleted] = useState(false);
  const [deals, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [categoryData, SetCategory] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    UserService.getCategory().then((res) => SetCategory(res.data)).catch((err) => console.error("Failed to load categories", err))
    UserService.getDeals(0, PAGE_SIZE).then((res) => {
      setData(res.data)
      setIsCompleted(res.data.length < PAGE_SIZE)
      setpagenumber(1)
    }).catch((err) => {
      console.error("Failed to load deals", err)
      setError(true);
    }).finally(() => setLoading(false))
  }, []);

  const loadMore = () => {
    setLoadingMore(true)
    UserService.getDeals(pagenumber, PAGE_SIZE).then((res) => {
      setData((prev) => prev.concat(res.data))
      setIsCompleted(res.data.length < PAGE_SIZE)
      setpagenumber(pagenumber + 1)
    }).catch((err) => console.error("Failed to load more deals", err))
      .finally(() => setLoadingMore(false))
  }

  // old: const categoryLinks = categoryData.map((category) =>
  // new: only show categories that have deals
  const categoryLinks = categoryData.filter(hasDeals).map((category) =>
    <a key={category.category_id ?? category.category} href={"/category/" + category.category}>{category.category}</a>
  )

  return (
    <>
      <Hero />
      <div className="home-page">
        <div className="home-layout">
          <main>
            <nav className="home-cat-chips" aria-label="Categories">{categoryLinks}</nav>

            <h2 className="home-section-title" id="deals">Latest Deals</h2>

            {error ? (
              <p className="home-message">Something went wrong loading deals. Please refresh the page in a minute.</p>
            ) : loading ? (
              <div className="home-message">
                <Spinner animation="border" />
                <p>Loading today's deals...</p>
              </div>
            ) : (
              <>
                <div className="deal-grid">
                  {deals.map((deal) => <DealCard key={deal.id} deal={deal} />)}
                </div>
                <div className="home-loadmore">
                  {iscompleted ? (
                    <button type='button' disabled>No more deals</button>
                  ) : (
                    <button type='button' onClick={loadMore} disabled={loadingMore}>
                      {loadingMore ? "Loading..." : "Show More Deals"}
                    </button>
                  )}
                </div>
              </>
            )}

            <SignUp />
          </main>

          <aside className="home-sidebar">
            <div className="home-sidebar-box">
              <h3>Shop by Category</h3>
              {categoryLinks}
            </div>
          </aside>
        </div>
      </div>
    </>
  )
}

export default Home2;
